<script>
// import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import "@/assets/css/myCustomDashboardPeserta.css";
// import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import router from "@/router";

import HeaderSoalPeserta from "./components/header-soal-peserta.vue";
import ModalProgress from "./components/modal-progress.vue";
import ModalProrgessFinal from "./components/modal-progress-final.vue";
import ProctorPermissionsInfo from "./components/proctor-permissions-info.vue";

import InstruksiSoalPilihanGanda from "./components/pilihan-ganda/instruksi-soal-pilihan-ganda.vue";
import InstruksiSoalBenarSalah from "./components/benar-salah/instruksi-soal-benar-salah.vue";
import InstruksiSoalMenjodohkan from "./components/menjodohkan/instruksi-soal-menjodohkan.vue";
import PetunjukSoalPilihanGanda from "./components/pilihan-ganda/petunjuk-soal-pilihan-ganda.vue";
import PetunjukSoalBenarSalah from "./components/benar-salah/petunjuk-soal-benar-salah.vue";
import PetunjukSoalMenjodohkan from "./components/menjodohkan/petunjuk-soal-menjodohkan.vue";
import SoalPilihanGanda from "./components/pilihan-ganda/soal-pilihan-ganda.vue";
import SoalBenarSalah from "./components/benar-salah/soal-benar-salah.vue";
import SoalMenjodohkan from "./components/menjodohkan/soal-menjodohkan.vue";
import InstruksiSoalText from "./components/text/instruksi-soal-text.vue";
import PetunjukSoalText from "./components/text/petunjuk-soal-text.vue";
import SoalText from "./components/text/soal-text.vue";

import AutoProctorService from "@/helpers/AutoProctorService.js";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
    // PageHeader,
    HeaderSoalPeserta,
    ModalProgress,
    ModalProrgessFinal,
    ProctorPermissionsInfo,

    InstruksiSoalPilihanGanda,
    InstruksiSoalBenarSalah,
    InstruksiSoalMenjodohkan,
    PetunjukSoalPilihanGanda,
    PetunjukSoalBenarSalah,
    PetunjukSoalMenjodohkan,

    SoalPilihanGanda,
    SoalBenarSalah,
    SoalMenjodohkan,
    InstruksiSoalText,
    PetunjukSoalText,
    SoalText,
  },
  data() {
    return {
      title: "Dashboard Soal",
      items: [
        {
          text: "Dashboards Soal",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,

      proctoringConfiguration: {
        used: false,
        loading: true,
        activeStatus: false,
        preview: true,

        credentials: {
          // client_id: "byR90kNH",
          // client_secret: "YpBwpLvggNBMFxQ",
          client_id: process.env.VUE_APP_AUTOPROCTORING_CLIENT_ID,
          client_secret: process.env.VUE_APP_AUTOPROCTORING_CLIENT_SECRET,
          testAttemptId: null,
        },
        
        options: {
          trackingOptions: {
            audio: true,
            numHumans: true,
            tabSwitch: true,
            photosAtRandom: true,
            numPhotosAtRandom: 3,
            captureSwitchedTab: true,
            detectMultipleScreens: true,
            recordSession: false,
            forceFullScreen: false
          },
          testContainerId: "mym-quizz-container",
          showHowToVideo: false
        },
      },
      proctorLiveEvents: [],
      persistentViolations: [],
      apRealtimeStarted: false,
      proctoringStarted: false,
      permissionMonitors: [],
      permissionLostAlertShown: false,

      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      dataListJadwal: [],
      nama_peserta: "-",
      jabatan_peserta: "-",
      data_peserta: null,
      app_sso: "",
      token_jadwal: "",
      isOpen: false,
      configs: {},
      info_ujian: "",
      isDone: true,
      isSimulasi: false,

      // Durasi pengerjaan
      duration: 60 * 60,
      timeLeft: 60 * 60,
      timerInterval: null,

      nip_peserta: localStorage.nip_peserta,

      

      // Proses simpan data
      progressSaveData: null,

      modalConfiguration: {
        progress: false,
        progressFinal: false,
      },

      currentIndex: 0,
      answers: [],
      reviewList: [],
      showModalInstruction: false,

      viewportHeight: window.innerHeight,

      // Data Soal
      listItem: [],
      soal: [],
      soalMenjodohkan: [],
      tipe: "",
      countdown: 0,
      last_page: 0,
      numPage: 0,

      isLoadingSoal: false,

      currentPage: 1,
      perPage: 1,
      paramSoal: null,
      id_kompetensi: null,
      id_jadwal: null,
      id_jadwal_peserta: null,
      id_jadwal_batch: null,
      id_status: null,
      index_soal: 0,
      is_instruksi: 0,
      nama_kompetensi: "-",
      status_pengerjaan: 0,

      dataInfo: null,
      dataInfoPilihanGanda: null,
      dataInfoBenarSalah: null,
      dataInfoMenjodohkan: null,
      dataInfoText: null,
    };
  },

  computed: {
    getHeaderHeight() {
      const height = this.$refs.quizChild.$refs.quizHeader?.offsetHeight || 0;
      return ((height + 10) / this.viewportHeight) * 100;
      // return height + 20 + 45 + "px";
    },

    formattedTime() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
    },

    soalStats() {
      const filtered = this.listItem.filter((item) => item.is_instruksi === 0);

      const total = filtered.length;
      const answered = filtered.filter(
        (item) => item.jawaban_peserta !== null
      ).length;
      const unanswered = total - answered;
      const progress = total > 0 ? ((answered / total) * 100).toFixed(1) : 0;

      return {
        total,
        answered,
        unanswered,
        progress,
      };
    },

    currentQuestion() {
      return this.soal?.[0];
    },

    currentQuestionOptionList() {
      return this.soal?.[0]?.jawaban || [];
    },
    currentQuestionShuffleOptionList() {
      let options = [...this.currentQuestionOptionList];
      return this.shuffleArray(options);
    },

    currentQuestionMenjodohkan() {
      return (
        this.listItem?.filter(
          (item) => item.tipe === "Menjodohkan" && item.is_instruksi === 0
        ) ?? []
      );
    },

    allIdQuestionMenjodohkan() {
      return this.currentQuestionMenjodohkan.map((item) => item.idsoal) ?? [];
    },

    hasImageOptions() {
      const options = this.currentQuestion?.jawaban ?? [];
      const result = options.some(
        (opt) => opt.jawaban && opt.jawaban.startsWith("/storage/file_manager")
      );
      return result;
    },

    groupedItems() {
      const grouped = [];
      let currentIndex = 0;
      let reset = 0;
      // Distribute items in each row (6, 4, 6, 4, ...)
      for (let rowIndex = 0; currentIndex < this.listItem.length; rowIndex++) {
        const rowLength = 6;
        const rowItems = this.listItem.slice(
          currentIndex,
          currentIndex + rowLength
        );

        // Iterate through rowItems to add index or null based on is_instruksi
        let instruksi = 0;
        // console.log("rowItems: ", rowItems);
        const updatedRowItems = rowItems.map((item) => {
          if (item.is_instruksi === 1) {
            instruksi = instruksi + 1;
            reset = 0;
            return { ...item, nomor_urut: null };
          } else {
            reset++;
            return {
              ...item,
              nomor_urut: reset,
            };
          }
        });

        grouped.push(updatedRowItems);
        currentIndex += rowLength;
      }
      // console.log("grouped: ", grouped);
      // console.log("listItem: ", this.listItem);

      return grouped;
    },

    groupedItems3() {
      let result = [];
      let nomor_urut = 0;
      this.listItem.forEach((e) => {
        if (e.is_instruksi === 1) {
          nomor_urut = 0;
        } else {
          nomor_urut++;
          result[e.idsoal] = {
            nomor_urut: nomor_urut,
          };
        }
      });

      return result;
    },
  },

  async mounted() {
    let self = this;
    self.setParamSoal();

    if (self.id_status && self.id_jadwal_peserta) {
      const bisaMasuk = await self.checkStatusPengerjaanAsesmen();
      if (!bisaMasuk) {
        // Kunci history agar tombol back tidak kembali ke halaman soal
        history.pushState(null, "", location.href);
        const blockBackNav = () => {
          history.pushState(null, "", location.href);
        };
        window.addEventListener("popstate", blockBackNav);

        await Swal.fire({
          icon: "warning",
          title: "Tidak Dapat Masuk",
          text: "Terdapat asesmen lain yang sedang dikerjakan. Selesaikan terlebih dahulu sebelum memulai asesmen ini.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
          confirmButtonText: "Kembali ke Dashboard",
        });

        window.removeEventListener("popstate", blockBackNav);
        self._navigationConfirmed = true;
        await self.cleanupProctoring();
        self.$router.replace({ name: "dashboard-assesmen-hc" });
        return;
      }
    }

    const proctorPermissions = await self.proctorCheckPermissions();

    if (!proctorPermissions) {
      this.proctoringConfiguration.loading = false;
      this.proctoringConfiguration.preview = false;
    }

    // Ambil is_proctoring dari jadwal sebelum load SDK & config
    await this.getIsProctoring();

    if (!this.proctoringConfiguration.used) {
      this.proctoringConfiguration.preview = false;
    }

    // Load SDK dan config proctoring secara paralel agar sudah siap sebelum user klik "Mulai Asesmen"
    await Promise.all([
      this.loadAutoProctorScripts(),
      this.proctoringConfiguration.used ? this.getConfigProctor() : Promise.resolve()
    ])

    if (!this.proctoringConfiguration.used) {
      await this.$nextTick();
      this.cekParamSoal();
    }

    window.addEventListener("resize", self.updateViewportHeight);

    history.pushState(null, '', location.href);
    window.addEventListener('popstate', this._handlePopState);
    window.addEventListener('beforeunload', this._handleBeforeUnload);
  },

  methods: {
    async checkStatusPengerjaanAsesmen() {
      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/cek-status-asesmen-berlangsung",
          params: {
            idjadwal: this.id_jadwal,
            idjadwal_peserta: this.id_jadwal_peserta,
            idkompetensi: this.id_kompetensi,
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token_peserta,
          },
        });
        if (response.data.meta.code === 200) {
          return response.data.data;
        }
        return false;
      } catch (error) {
        console.log("checkStatusPengerjaanAsesmen error:", error);
        return false;
      }
    },

    _handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = '';
    },

    async _handlePopState() {
      history.pushState(null, '', location.href);

      if (this._popstateHandling) return;
      this._popstateHandling = true;

      await Swal.fire({
        icon: 'warning',
        title: 'Tidak Dapat Keluar!',
        text: 'Anda tidak diperbolehkan meninggalkan halaman ujian selama sesi berlangsung.',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      this._popstateHandling = false;
    },

    // Load AutoProctor SDK
    async loadAutoProctorScripts() {
      await this.loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js"
      )

      await this.loadScript(
        "https://cdn.autoproctor.co/ap-entry.js"
      )
    },

    // Load Script 
    loadScript(src) {
      return new Promise((resolve, reject) => {
        // prevent duplicate load
        const existingScript = document.querySelector(
          `script[src="${src}"]`
        )

        if (existingScript) {
          resolve()
          return
        }

        const script = document.createElement("script")
        script.src = src
        script.defer = true

        script.onload = () => resolve()
        script.onerror = () =>
          reject(new Error(`Failed to load: ${src}`))

        document.head.appendChild(script)
      })
    },

    // cek permission proctoring
    async proctorCheckPermissions() {
      const result = await AutoProctorService.checkPermissions();
      this.proctoringConfiguration.activeStatus = result.success;
      this.proctoringConfiguration.loading = false;
      if(!result.success) {
        Swal.fire({
          icon: "error",
          title: "Izin Akses Diperlukan.",
          text: result.message,
        });

        return false;
      }

      AutoProctorService.cleanup();
      return true;
    },

    async stopPreviewProctoring(){
      this.proctoringConfiguration.preview = false;

      AutoProctorService.stopCamera();
      AutoProctorService.stopScreenShare();

      // Gunakan $nextTick agar DOM update selesai, lalu langsung panggil cekParamSoal
      // tanpa delay tambahan supaya user gesture window (untuk getDisplayMedia di SDK) tidak kadaluarsa
      await this.$nextTick();
      this.cekParamSoal();
    },

    async getIsProctoring() {
      try {
        const encryptedParam = this.$route.query.soal;
        if (!encryptedParam) return;

        const decrypted = CryptoJS.AES.decrypt(encryptedParam, "4lfahumaNeEd5ME!").toString(CryptoJS.enc.Utf8);
        const idJadwal = decrypted.split("_")[2];

        if (!idJadwal) return;

        const res = await axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "peserta/proctoring-used/" + idJadwal,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.access_token_peserta}`,
          },
        });

        const meta = res?.data?.meta;
        if (meta?.code == 200) {
          const data = res?.data?.data;
          // console.log('Hasil Response', data?.is_proctoring);
          this.proctoringConfiguration.used = data?.is_proctoring == 1;
        }
      } catch (err) {
        console.log("err getIsProctoring:", err);
        this.proctoringConfiguration.used = false;
      }
    },

    // AutoProctor
    async getConfigProctor() {
      try {
        Swal.fire({
          title: 'Loading...',
          text: 'Sedang mengambil data config',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const res = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "peserta/config-proctor-peserta",
          method: 'get',
          params: {
            idjadwal: this.id_jadwal,
          },
          headers: {
            Authorization: `Bearer ${localStorage.access_token_peserta}`
          },
        });

        let meta = res?.data?.meta;

        if (meta?.code == 200) {

          let data = res?.data?.data || {};

          let trackingOptions = {
            ...this.proctoringConfiguration.options.trackingOptions
          };

          Object.entries(data).forEach(([key, val]) => {
            if (key in trackingOptions) {
              trackingOptions[key] = !!val.status;
            }
          });

          this.proctoringConfiguration.options.trackingOptions = trackingOptions;

          console.log(
            'get config',
            this.proctoringConfiguration.options.trackingOptions
          );

        } else {
          Swal.fire(
            'Peringatan',
            'Terdapat kendala saat mengambil data config',
            'warning'
          );
        }

      } catch (err) {

        console.log(err);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Terjadi kesalahan pada sistem',
          showConfirmButton: true,
        });

      } finally {
        Swal.close();
      }
    },

    async startAutoProctor() {
      try {

        const credentials =
        AutoProctorService.generateCredentials(
          this.proctoringConfiguration.credentials.client_id,
          this.proctoringConfiguration.credentials.client_secret,
        )

        this.proctoringConfiguration.credentials.testAttemptId = credentials.testAttemptId;

        const setupResult = await AutoProctorService.setup(
          credentials,
          this.proctoringConfiguration.options
        )

        if (!setupResult.success) {
          console.error("AutoProctor Setup Failed:", setupResult.message)
          return false
        }

        const forceFullScreen = this.proctoringConfiguration.options.trackingOptions.forceFullScreen

        // Ketika forceFullScreen aktif, user perlu masuk fullscreen dulu sebelum SDK siap.
        // Beri waktu 5 menit agar user sempat berinteraksi dengan prompt fullscreen dari SDK.
        const readyTimeout = forceFullScreen ? 5 * 60 * 1000 : 30000

        // Register listener BEFORE calling start to avoid missing the apMonitoringStarted event
        const readyPromise = AutoProctorService.waitUntilReady(readyTimeout)

        const startResult = await AutoProctorService.start()

        if (!startResult.success) {
          console.error("AutoProctor Start Failed:", startResult.message)
          return false
        }

        // Tutup Swal loading SEKARANG supaya user bisa melihat dan berinteraksi dengan
        // prompt fullscreen dari SDK. Jika Swal tetap terbuka, prompt SDK tertutup oleh overlay.
        Swal.close()

        const ready = await readyPromise

        // Violations yang terjadi sebelum realtime listener aktif (misal dual monitor
        // terdeteksi saat startup) dikembalikan dari waitUntilReady agar tidak hilang.
        if (ready.startupViolations?.length) {
          this.proctorLiveEvents.push(...ready.startupViolations)
          // Simpan juga sebagai persistent — pelanggaran ini masih berlangsung selama
          // user belum mencabut monitor kedua, harus ikut terkirim di setiap soal.
          ready.startupViolations.forEach(v => {
            this._upsertPersistentViolation(v)
          })
        }

        if (!ready.success) {
          if (ready.sdkError) {
            // Hard error dari SDK (apErrorEvent) — proctor benar-benar tidak berjalan
            console.error("AutoProctor SDK error during startup:", ready.message)
            return false
          }
          if (forceFullScreen) {
            // User tidak masuk fullscreen dalam waktu yang diberikan — jangan lanjutkan ujian
            console.error("AutoProctor: user did not enter fullscreen within timeout")
            return false
          }
          // Timeout saja dan fullscreen tidak diwajibkan: apMonitoringStarted tidak selalu
          // di-dispatch tergantung konfigurasi SDK. start() sudah sukses, set status manual.
          console.warn("AutoProctor ready event not received (timeout):", ready.message)
          AutoProctorService.status.proctorStarted = true
        }

        console.log("AutoProctor started")
        this.proctoringStarted = true
        this.initAutoProctorEventRealtime()
        this.startPermissionMonitoring()
        return true

      } catch (error) {
        console.error(error)

        return false
      }
    },

    initAutoProctorEventRealtime() {
      if (this.apRealtimeStarted) return
      this.apRealtimeStarted = true

      this.proctorLiveEvents = []

      // =========================
      // EVIDENCE (MOST IMPORTANT)
      // =========================
      window.addEventListener("apEvidenceEvent", (e) => {
        console.log("EVIDENCE:", e.detail)

        this.proctorLiveEvents.push({
          type: "evidence",
          code: e.detail.evidenceCode,
          count: e.detail.violationCount,
          url: e.detail.evidenceURL,
          timestamp: new Date().toISOString(),
          testAttemptId: this.proctoringConfiguration.credentials.testAttemptId,
        })
      })

      // =========================
      // SUCCESS EVENTS
      // =========================
      window.addEventListener("apSuccessEvent", (e) => {
        console.log("SUCCESS:", e.detail)

        this.proctorLiveEvents.push({
          type: "success",
          code: e.detail.successCode,
          timestamp: new Date().toISOString(),
          testAttemptId: this.proctoringConfiguration.credentials.testAttemptId,
        })
      })

      // =========================
      // ERROR EVENTS
      // =========================
      const NON_BLOCKING_CODES = new Set([4015])

      window.addEventListener("apErrorEvent", (e) => {
        console.log("ERROR:", e.detail)

        const violation = {
          type: "error",
          code: e.detail.errorCode,
          timestamp: new Date().toISOString(),
          testAttemptId: this.proctoringConfiguration.credentials.testAttemptId,
        }

        this.proctorLiveEvents.push(violation)

        // Non-blocking = pelanggaran yang masih berlangsung (misal dual monitor).
        // Update persistent agar selalu ikut terkirim di setiap soal berikutnya.
        if (NON_BLOCKING_CODES.has(e.detail.errorCode)) {
          this._upsertPersistentViolation(violation)
        }
      })

      // =========================
      // TAB / FOCUS (optional extra layer)
      // =========================
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          this.proctorLiveEvents.push({
            type: "tab_hidden",
            timestamp: new Date().toISOString(),
            testAttemptId: this.proctoringConfiguration.credentials.testAttemptId,
          })
        }
      })

      console.log("AutoProctor realtime event system started")
    },

    async startPermissionMonitoring() {
      const handlePermissionRevoked = (label) => {
        if (this.permissionLostAlertShown) return;
        this.permissionLostAlertShown = true;

        Swal.fire({
          icon: 'warning',
          title: 'Akses Dicabut!',
          html: `Akses <strong>${label}</strong> telah dimatikan.<br>Anda tidak dapat melanjutkan ujian.`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
          confirmButtonText: 'Keluar Ujian',
          confirmButtonColor: '#dc3545',
        }).then(async () => {
          this._navigationConfirmed = true;
          await this.cleanupProctoring()
          this.$router.replace({ name: 'dashboard-assesmen-hc' });
        });
      };

      const permissionsToCheck = [
        { name: 'camera', label: 'Kamera' },
        { name: 'microphone', label: 'Mikrofon' },
        { name: 'display-capture', label: 'Berbagi Layar' },
      ];

      for (const perm of permissionsToCheck) {
        try {
          const status = await navigator.permissions.query({ name: perm.name });

          const onChange = () => {
            if (status.state !== 'granted') {
              handlePermissionRevoked(perm.label);
            }
          };

          status.addEventListener('change', onChange);
          this.permissionMonitors.push({ status, onChange });
        } catch (e) {
          console.warn(`Permission '${perm.name}' tidak dapat dimonitor:`, e);
        }
      }
    },

    async stopAutoProctor() {
      if(!this.proctoringConfiguration.used){
        Swal.fire({
          icon: 'info',
          title: 'Info',
          text: 'Tidak ada proctor yang berjalan.',          
          showConfirmButton: true,
        });
        return
      }

      if (this.isSavingProctor) return

      this.isSavingProctor = true

      try {
        const result = await AutoProctorService.stop()

        if (!result.success) {
          // Gagal stop bukan error yang perlu diperlihatkan ke user — cukup log dan lanjut
          console.error('AutoProctor stop failed:', result.message)
          return
        }

        // SDK tidak pernah benar-benar berjalan (apMonitoringStarted tidak fired),
        // atau SDK sudah menghentikan dirinya sendiri (misal forceFullScreen + user keluar fullscreen)
        if (result.neverStarted) {
          console.warn('AutoProctor was not in started state, skipping report retrieval')
          return
        }

        const finalReport = await this.waitAutoProctorResult()

        if (!finalReport || !finalReport.testAttemptStatus) {
          // Report belum tersedia — jangan blokir penyelesaian ujian, cukup log
          console.warn('AutoProctor: final report not available, skipping save')
          return
        }

        await this.saveAutoProctorResult(finalReport)
      } catch (err) {
        // Tangkap error tak terduga — log saja, jangan blokir user dengan alert
        console.error('AutoProctor stopAutoProctor unexpected error:', err)
      } finally {
        await AutoProctorService.clearInstances()
        this.isSavingProctor = false
      }
    },

    async saveAutoProctorResult(finalReport) {
      try {
        Swal.fire({
          title: "Saving proctoring result...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading()
        })

        const payload = {
          idjadwal: this.id_jadwal,
          idjadwal_batch: this.id_jadwal_batch,
          idjadwal_peserta: this.id_jadwal_peserta,
          idstatus_peserta: this.id_status,
          idkompetensi: this.id_kompetensi,

          raw_data: finalReport,
          testAttemptId: this.proctoringConfiguration.credentials.testAttemptId,
        }

        const response = await axios({
          method: "post",
          url: this.BACKEND_URL_VERSION + "peserta/jadwal-peserta/save-proctor-asesmen-peserta",
          data: payload,
          headers: {
            Accept: "application/json",
            Authorization:
              "Bearer " + localStorage.access_token_peserta
          }
        })

        Swal.close()

        // console.log('Response save proctor', response);
        const result = response.data.data

        if (!result.status) {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text:
              result.message ||
              "Failed to save proctoring result"
          })

        } else {
          // Swal.fire({
          //   icon: "success",
          //   title: "Saved",
          //   text:
          //     "Proctoring result saved. Total evidence: " +
          //     result.total_evidence
          // })
        }

        return response.data

      } catch (error) {
        Swal.close()

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.meta?.message ||
            error.message
        })


        return {
          status: false,
          message: error.message
        }
      }
    },

    async waitAutoProctorResult() {
      let maxTry = 5
      let counter = 0

      while (counter < maxTry) {
        const result =
          await this.getAutoProctorResult()

        if (
          result?.testAttemptStatus !== "started" &&
          result?.evidenceStatus === "processed"
        ) {
          return result
        }

        counter++
        await new Promise(r => setTimeout(r, 5000))
      }

      return null
    },

    async getAutoProctorResult() {

      const result =
        await AutoProctorService.getResults(
          this.proctoringConfiguration.credentials.client_id,
          this.proctoringConfiguration.credentials.client_secret,
          this.proctoringConfiguration.credentials.testAttemptId,
        )

      // console.log('hasil proctor', result);
      return result
    },

    async cekParamSoal() {
      this.isLoadingSoal = true;
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      this.paramSoal = this.$route.query.soal;
      if (
        this.paramSoal === null ||
        this.paramSoal === "" ||
        !this.$route.query.soal
      ) {
        this.isLoadingSoal = false;
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Soal tidak ditemukan, silahkan menuju ke halaman dashboard",
          showCancelButton: false,
          confirmButtonText: "Kembali ke Dashboard",
        }).then(async (result) => {
          if (result.isConfirmed) {
            this._navigationConfirmed = true;
            await this.cleanupProctoring()
            this.$router.push({
              name: "dashboard-assesmen-hc",
            });
          }
        });
      } else {
        let get_param = CryptoJS.AES.decrypt(
          this.paramSoal,
          "4lfahumaNeEd5ME!"
        ).toString(CryptoJS.enc.Utf8);

        await this.getDataFromParam(get_param);
        // Start Auto Proctoring
        if(this.proctoringConfiguration.used){
          Swal.fire({
            title: 'Memulai Sistem Proctoring...',
            html: 'Mohon tunggu, sistem pengawasan ujian sedang dipersiapkan.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          await AutoProctorService.clearInstances()
          const started = await this.startAutoProctor()

          if (started) {
            this.saveInitialProctoringEvidence()
          }

          if (!started) {
            Swal.fire({
              icon: 'error',
              title: 'Gagal Memulai Proctoring',
              html: 'Terjadi kendala saat memulai sistem proctor.<br>Silakan kembali ke dashboard dan coba lagi.',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: false,
              confirmButtonText: 'Kembali ke Dashboard',
              confirmButtonColor: '#dc3545',
            }).then(async () => {
              this._navigationConfirmed = true;
              this.isLoadingSoal = false;
              await this.cleanupProctoring()
              this.$router.replace({ name: 'dashboard-assesmen-hc' });
            });
            return;
          }

          // startAutoProctor() menutup Swal-nya sendiri agar prompt fullscreen SDK terlihat.
          // Tampilkan kembali loading untuk proses memuat data soal.
          Swal.fire({
            title: 'Memuat soal...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => { Swal.showLoading(); }
          });
        }

        await this.getListSoal();
        await this.getSoal();
        this.startTimer();
        // this.disableShortcuts();
        Swal.close();
        await this.$nextTick();
        this.restoreBodyScroll();
        this.isLoadingSoal = false;
      }
    },

    setParamSoal(){
      this.paramSoal = this.$route.query.soal;
      if (
        this.paramSoal === null ||
        this.paramSoal === "" ||
        !this.$route.query.soal
      ) {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Soal tidak ditemukan, silahkan menuju ke halaman dashboard",
          showCancelButton: false,
          confirmButtonText: "Kembali ke Dashboard",
        }).then(async (result) => {
          if (result.isConfirmed) {
            this._navigationConfirmed = true;
            await this.cleanupProctoring()
            this.$router.push({
              name: "dashboard-assesmen-hc",
            });
          }
        });
      } else {
        let get_param = CryptoJS.AES.decrypt(
          this.paramSoal,
          "4lfahumaNeEd5ME!"
        ).toString(CryptoJS.enc.Utf8);

        this.getDataFromParam(get_param);
      }
    },

    getDataFromParam(param) {
      let splittedArray = param.split("_");

      this.id_kompetensi = splittedArray[0];
      this.id_jadwal_peserta = splittedArray[1];
      this.id_jadwal = splittedArray[2];
      this.id_jadwal_batch = splittedArray[3];
      this.timer = splittedArray[4] * 60;
      this.nama_kompetensi = splittedArray[5];
      this.id_kompetensi = splittedArray[6];
      this.level = splittedArray[7];
      this.id_status = splittedArray[8];
      this.countdown = splittedArray[4] * 60;
    },

    async getListSoal() {
      let self = this;
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/list-soal-peserta",
          {
            params: {
              id_kompetensi: this.id_kompetensi,
              idjadwal: this.id_jadwal,
              idjadwal_peserta: this.id_jadwal_peserta,
              level: this.level,
              is_simulasi: localStorage.getItem("is_simulasi"),
              uniqueId: localStorage.getItem("uniqueId"),
              // tipe: "Pilihan Ganda",
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          }
        );

        let response_data = response.data;
        self.last_page = response_data.data.length;
        let data = response.data.data;

        if (response_data.meta.code == 200) {
          self.listItem = data;
          self.getCurrentIndex();
          // self.groupedItems();
          // await self.groupedItems2();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.data.message,
          });
        }
      } catch (errors) {
        console.log(errors);
      }
    },

    async getSoal() {
      let tipeSoal = this.listItem[this.index_soal]?.tipe;
      this.tipe = tipeSoal
      console.info("Tipe soal saat ini:", tipeSoal);
      if (
        tipeSoal === "Menjodohkan" &&
        this.listItem[this.index_soal]?.is_instruksi === 0
      ) {        
        this.is_instruksi = this.listItem[this.index_soal].is_instruksi;
        await this.getAllSoalMenjodohkan();
        return;
      }
      

      let self = this;

      // Show loading indicator
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const payload = {
          // id_kompetensi: this.id_kompetensi,

          id_soal: this.listItem[this.index_soal].idsoal,
          tipe: this.listItem[this.index_soal].tipe,
          id_jadwal_peserta: this.id_jadwal_peserta,
          is_simulasi: localStorage.getItem("is_simulasi"),
          uniqueId: localStorage.getItem("uniqueId"),
          // per_page: self.perPage,
          // page: self.currentPage,
        };

        // const encryptedPayload = encryptData(payload);
        let response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/soal-peserta",
          {
            params: payload,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          }
        );

        let response_data = response.data;
        let response_page = response.data.data;
        let data = response.data.data.data;
        // Close loading indicator
        Swal.close();

        if (response_data.meta.code == 200) {
          self.soal = data;
          self.tipe =
            self.soal[0]?.tipe || this.listItem[this.index_soal]?.tipe;
          self.perPage = response_page.per_page;
          self.currentPage = response_page.current_page;
          self.is_instruksi = this.listItem[this.index_soal].is_instruksi;
          let urutanSoal = await self.groupedItems3();
          this.nomor_urut = urutanSoal[self.soal[0].idsoal];
          // if (self.currentPage == 1 || self.countdown == 0) {
          //   self.countdown = self.timer;
          //   self.startTimer();
          // } else {
          //   self.countdown = self.timer;
          // }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.data.message,
          });
        }
      } catch (errors) {
        // Close loading indicator in case of an error
        Swal.close();
        // console.log(errors);
      }
    },

    async getAllSoalMenjodohkan() {
      if (!this.allIdQuestionMenjodohkan?.length) {
        return;
      }

      let self = this;

      // Show loading indicator
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const payload = {
          // id_kompetensi: this.id_kompetensi,

          id_soal: [...this.allIdQuestionMenjodohkan],
          id_jadwal_peserta: this.id_jadwal_peserta,
          is_simulasi: localStorage.getItem("is_simulasi"),
          uniqueId: localStorage.getItem("uniqueId"),
          // per_page: self.perPage,
          // page: self.currentPage,
        };

        // const encryptedPayload = encryptData(payload);
        let response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/soal-peserta-menjodohkan",
          {
            params: payload,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          }
        );

        let response_data = response.data;
        let data = response.data.data.data;
        // Close loading indicator
        Swal.close();

        if (response_data.meta.code == 200) {
          self.soalMenjodohkan = data;

          self.is_instruksi = this.listItem[this.index_soal].is_instruksi;
          // self.tipe = 'Menjodohkan'; // Already set
          self.nomor_urut = data[0]?.nomor_urut ?? 1;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.data.message,
          });
        }
      } catch (errors) {
        // Close loading indicator in case of an error
        Swal.close();
        // console.log(errors);
      }
    },

    async infoPengerjaan(tipe) {
      // console.log('Info tipe', tipe);
      switch (tipe) {
        case "Pilihan Ganda":
          this.dataInfoPilihanGanda =
            this.dataInfoPilihanGanda ?? (await this.getInfoPengerjaan(tipe));
          this.dataInfo = this.dataInfoPilihanGanda;
          break;
        case "Benar Salah":
          this.dataInfoBenarSalah =
            this.dataInfoBenarSalah ?? (await this.getInfoPengerjaan(tipe));
          this.dataInfo = this.dataInfoBenarSalah;
          break;
        case "Menjodohkan":
          this.dataInfoMenjodohkan =
            this.dataInfoMenjodohkan ?? (await this.getInfoPengerjaan(tipe));
          this.dataInfo = this.dataInfoMenjodohkan;
          break;
        case "Text":
          this.dataInfoText =
            this.dataInfoText ?? (await this.getInfoPengerjaan(tipe));
          this.dataInfo = this.dataInfoText;
          break;
        default:
          break;
      }
      this.showModalInstruction = true;
      // console.log('ambil data info', this.dataInfo);
    },

    async getInfoPengerjaan(tipe) {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      let soal = this.listItem.find(
        (e) => e.is_instruksi == 1 && e.tipe == tipe
      );
      const payload = {
        id_soal: soal.idsoal,
        tipe: soal.tipe,
        id_jadwal_peserta: this.id_jadwal_peserta,
        is_simulasi: localStorage.getItem("is_simulasi"),
        uniqueId: localStorage.getItem("uniqueId"),
      };
      // const encryptedPayload = encryptData(payload);
      let response = await axios.get(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "peserta/jadwal-peserta/soal-peserta",
        {
          params: payload,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token_peserta,
          },
        }
      );
      let response_data = response.data;
      let data = response.data.data.data;
      let dataInfo = {};   
      if (response_data.meta.code == 200) {
        dataInfo = tipe == "Menjodohkan" || tipe == "Text" ? data : data[0];
      }
      Swal.close();

      return dataInfo;
    },

    getQuestionNumber(index) {
      return this.listItem
        .slice(0, index + 1)
        .filter((item) => item.is_instruksi !== 1).length;
    },

    // getCurrentIndex() {
    //   /**
    //    * todo: tampilkan soal berikutnya dari soal yang sudah terjawab
    //    * todo: jika soal terakhir yang terjawab, maka tampilkan soal terakhir tersebut
    //    * todo: countdown ambil dari time_remaining dari jawaban terakhir
    //    */
    //   this.listItem.forEach((element, index) => {
    //     if (element.is_instruksi == 0) {
    //       if (element.jawaban_peserta != null) {
    //         this.countdown = element.jawaban_peserta.time_remaining * 60;
    //         if (this.index_soal != this.listItem.length - 1) {
    //           this.index_soal = index + 1;
    //         }
    //       }
    //     }
    //   });
    // },
    getCurrentIndex() {
      const hasAnyAnswer = this.listItem.some(
        (el) =>
          el.is_instruksi == 0 &&
          el.jawaban_peserta &&
          Object.keys(el.jawaban_peserta).length > 0
      );

      // =========================
      // CASE 1: NO ANSWERS YET
      // =========================
      if (!hasAnyAnswer) {
        const firstInstructionIndex = this.listItem.findIndex(
          (el) => el.is_instruksi == 1
        );

        this.index_soal =
          firstInstructionIndex !== -1 ? firstInstructionIndex : 0;
        return;
      }

      // =========================
      // CASE 2: HAS ANSWERS (RESUME MODE)
      // =========================
      let lastAnsweredIndex = -1;

      this.listItem.forEach((element, index) => {
        if (
          element.is_instruksi == 0 &&
          element.jawaban_peserta &&
          Object.keys(element.jawaban_peserta).length > 0
        ) {
          lastAnsweredIndex = index;

          this.countdown = element.jawaban_peserta.time_remaining * 60;
        }
      });

      const nextIndex = this.listItem.findIndex((el, i) => {
        const isAnswered =
          el.is_instruksi == 0 &&
          el.jawaban_peserta &&
          Object.keys(el.jawaban_peserta).length > 0;

        return i > lastAnsweredIndex && !isAnswered;
      });

      this.index_soal = nextIndex !== -1 ? nextIndex : lastAnsweredIndex;
    },

    formatTime(time) {
      return time < 10 ? `0${time}` : time;
    },

    startTimer() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.waktuHabis();
        }
      }, 1000); // Update every 1 second
    },

    waktuHabis() {
      Swal.fire({
        icon: "warning",
        title: "Waktu pengerjaan soal telah habis!",
        text: "Anda akan langsung diarahkan ke halaman berikutnya.",
        allowEscapeKey: false,
        allowOutsideClick: false,
      }).then(async () => {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        var config_store_data = {
          method: "post",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/submit-jawaban",
          data: {
            id_kompetensi: this.id_kompetensi,
            id_jadwal_peserta: this.id_jadwal_peserta,
            id_jadwal: this.id_jadwal,
            id_status: this.id_status,
            level: this.level,
            is_simulasi: localStorage.getItem("is_simulasi"),
            uniqueId: localStorage.getItem("uniqueId"),
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token_peserta,
          },
        };
        await axios(config_store_data)
          .then(function (response) {
            Swal.close();
            let response_data = response.data.data;
            if (response_data.meta.code == 200) {
              Swal.fire({
                icon: "success",
                title: "Selesai!",
                text: "Jawaban berhasil di simpan",
                timer: 2000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            // self.axiosCatchError = error.response.data.data;
          });

        let param_text =
          this.id_jadwal +
          "_" +
          this.id_jadwal_peserta +
          "_" +
          this.id_jadwal_batch +
          "_" +
          this.id_kompetensi +
          "_" +
          this.level +
          "_" +
          this.id_status;
        let my_param = CryptoJS.AES.encrypt(
          param_text,
          "4lfahumaNeEd5ME!"
        ).toString();
        this._navigationConfirmed = true;
        router.replace({
          name: "survey",
          query: { soal: my_param },
        });
      });
    },


    openProgress() {
      this.showModalProgress = true;
    },

    openProgressFinal() {
      this.showModalProgressFinal = true;
    },

    goToQuestion(i) {
      if (i < this.currentIndex) {
        // alert("Tidak bisa kembali ke soal sebelumnya");
        return;
      }

      this.currentIndex = i;
      this.showModalProgress = false;
    },

    backSoal() {
      let self = this;
      // console.log("currentPage", self.currentPage);
      // console.log("index_soal", self.index_soal);
      self.currentPage = self.currentPage - 1;
      self.index_soal = self.index_soal - 1;
      self.nomor_urut -= 1;

      self.getSoal();
    },

    nextSoal(number) {
      if (number != 0) {
        // const confirmMenjodohkan =
        //   this.tipe != "Menjodohkan"
        //     ? " dan tidak bisa kembali ke soal sebelumnya"
        //     : "";
        Swal.fire({
          title: "Apakah Anda telah yakin dengan jawaban yang dipilih?",
          // text: `Jika iya, halaman akan beralih ke soal berikutnya${confirmMenjodohkan}.`,
          html: `
            <div style="text-align:left;">
              <ul style="margin-top:10px; padding-left:20px;">
                <li>Pastikan jawaban telah dipilih dengan benar</li>
                <li>Pastikan koneksi jaringan Anda dalam kondisi stabil</li>
                <li>Soal yang telah dikerjakan tidak dapat diakses kembali ke soal sebelumnya.</li>
              </ul>

              <p style="margin-top:15px;">
                Jika sudah yakin, halaman akan beralih ke soal berikutnya.
              </p>
            </div>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ya",
        }).then((result) => {
          // <--
          if (result.value) {
            // <-- if confirmed
            Swal.fire({
              title: "Loading...",
              allowOutsideClick: false,
              showConfirmButton: false,
              willOpen: () => {
                Swal.showLoading();
              },
            });

            let jawabanBelumDijawab = false;

            let dataSoal = this.listItem[this.index_soal];
            if (
              dataSoal.is_instruksi !== 1 &&
              (!dataSoal.jawaban_peserta || dataSoal.jawaban_peserta === null)
            ) {
              jawabanBelumDijawab = true;
            }

            // console.log(jawabanBelumDijawab);
            // console.log(dataSoal.jawaban_peserta);
            // console.log(this.listItem);
            if (jawabanBelumDijawab) {
              // If there are unanswered questions, show the alert
              Swal.close();
              Swal.fire({
                title: "Belum ada Jawaban",
                text: "Mohon isi terlebih dahulu jawaban, sebelum melanjutkan",
                icon: "warning",
                confirmButtonText: "OK",
              });
            } else {
              let self = this;
              // self.stopTimer;
              self.currentPage = self.currentPage + 1;
              self.index_soal = self.index_soal + 1;
              number == 0 ? (self.nomor_urut = 1) : (self.nomor_urut += number);
              // self.nomor_urut += number;

              // console.log('last', self.last_page);
              self.getSoal();
            }
          }
        });
      } else {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        let jawabanBelumDijawab = false;

        let dataSoal = this.listItem[this.index_soal];
        if (
          dataSoal.is_instruksi !== 1 &&
          (!dataSoal.jawaban_peserta || dataSoal.jawaban_peserta === null)
        ) {
          jawabanBelumDijawab = true;
        }

        if (jawabanBelumDijawab) {
          // If there are unanswered questions, show the alert
          Swal.close();
          Swal.fire({
            title: "Belum ada Jawaban",
            text: "Mohon isi terlebih dahulu jawaban, sebelum melanjutkan",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          let self = this;
          // self.stopTimer;
          self.currentPage = self.currentPage + 1;
          self.index_soal = self.index_soal + 1;
          number == 0 ? (self.nomor_urut = 1) : (self.nomor_urut += number);
          // self.nomor_urut += number;
          // console.log('last', self.last_page);
          self.getSoal();
        }
      }

      // Show loading message
    },

    cekSelesai() {
      // Show loading message
      this.modalConfiguration.progressFinal = false;
      Swal.fire({
        title: "Mohon tunggu sebentar",
        text: "Sedang mengecek jawaban anda !!",
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "info",
        showConfirmButton: false,
      });

      let jawabanBelumDijawab = false;

      this.groupedItems.forEach((row) => {
        row.forEach((element) => {
          // console.log(element);
          if (
            element.is_instruksi !== 1 &&
            element.tipe !== "Text" &&
            (!element.jawaban_peserta || element.jawaban_peserta === null)
          ) {
            // Found an answered question
            jawabanBelumDijawab = true;
            return;
          }
        });
        if (jawabanBelumDijawab) {
          // Break the outer loop if an unanswered question is found
          return;
        }
      });

      if (jawabanBelumDijawab) {
        // If there are unanswered questions, show the alert
        Swal.fire({
          title: "Ada jawaban yang masih belum dijawab",
          icon: "warning",
          confirmButtonText: "OK",
        }).then(() => {
          // Set modalProgress to true when "OK" is clicked
          this.modalProgress = true;
        });
      } else {
        // If all questions are answered, call this.selesai
        this.selesai();
      }
    },

    disableShortcuts() {
      this._keydownHandler = (event) => {
        const isBlocked =
          event.key === 'Tab' ||
          event.key === 'Escape' ||
          event.key === 'F11' ||
          event.key === 'Alt';

        if (isBlocked || event.altKey) {
          event.preventDefault();
          event.stopPropagation();

          if (!Swal.isVisible()) {
            Swal.fire({
              icon: 'warning',
              title: 'Perhatian!',
              text: 'Anda tidak diperbolehkan menekan tombol tersebut selama ujian berlangsung.',
              timer:false,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        }
      };

      this._blurHandler = () => {
        if (!Swal.isVisible()) {
          Swal.fire({
            icon: 'warning',
            title: 'Perhatian!',
            text: 'Anda tidak diperbolehkan berpindah jendela atau tab selama ujian berlangsung.',
            confirmButtonText: 'Kembali ke Ujian',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      };

      window.addEventListener('keydown', this._keydownHandler, true);
      window.addEventListener('blur', this._blurHandler);
    },

    enableShortcuts() {
      if (this._keydownHandler) {
        window.removeEventListener('keydown', this._keydownHandler, true);
        this._keydownHandler = null;
      }
      if (this._blurHandler) {
        window.removeEventListener('blur', this._blurHandler);
        this._blurHandler = null;
      }
    },

    selesai() {
      // let self = this; // Store reference to Vue instance

      Swal.fire({
        icon: "warning",
        title: "Semua soal selesai dikerjakan!",
        text: "Apakah anda yakin untuk mengakhiri ujian?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Loading...",
            text: "Sedang menyimpan data, mohon tunggu.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          try {
            // Stop Auto Proctor
            if(this.proctoringConfiguration.used){
              await this.stopAutoProctor();
            }

            var config_store_data = {
              method: "post",
              url:
                process.env.VUE_APP_BACKEND_URL_VERSION +
                "peserta/jadwal-peserta/submit-jawaban",
              data: {
                id_kompetensi: this.id_kompetensi,
                id_jadwal_peserta: this.id_jadwal_peserta,
                id_jadwal: this.id_jadwal,
                id_status: this.id_status,
                level: this.level,
                is_simulasi: localStorage.getItem("is_simulasi"),
                uniqueId: localStorage.getItem("uniqueId"),
              },
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token_peserta,
              },
            };

            await axios(config_store_data)
              .then(function (response) {
                Swal.close();
                let response_data = response.data.data;
                if (response_data.meta.code == 200) {
                  Swal.fire({
                    icon: "success",
                    title: "Selesai!",
                    text: "Jawaban berhasil di simpan",
                    timer: 2000,
                    timerProgressBar: true,
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: response_data.data.message,
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
                // self.axiosCatchError = error.response.data.data;
              });
            let cek = await this.cekJawaban();
            if (cek == false) {
              Swal.fire({
                icon: "warning",
                title: "Terjadi Kesalahan",
                text: "Silahkan klik tombol selesai kembali",
              });
              return;
            }
            let param_text =
              this.id_jadwal +
              "_" +
              this.id_jadwal_peserta +
              "_" +
              this.id_jadwal_batch +
              "_" +
              this.id_kompetensi +
              "_" +
              this.level +
              "_" +
              this.id_status;
            let my_param = CryptoJS.AES.encrypt(
              param_text,
              "4lfahumaNeEd5ME!"
            ).toString();
            this.enableShortcuts();
            if (document.fullscreenElement) {
              await document.exitFullscreen();
            }
            this._navigationConfirmed = true;
            router.replace({
              name: "survey",
              query: { soal: my_param },
            });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message,
            });
          }

          this.modalProgress = false;
        } else {
          this.modalProgress = false;
        }
      });
    },

    selectAnswer(item, selectedJawaban) {
      // console.log(selectedJawaban);
      let self = this;

      self.simpanJawaban(item, selectedJawaban);
      // console.log(
      //   "Before:",
      //   item.jawaban.map((j) => j.selected)
      // );
      // Debugging log
      // Reset selected state for all jawabans in the current item
      item.jawaban.forEach((jawaban) => {
        jawaban.selected = false;
      });

      // Set selected state for the clicked jawaban
      selectedJawaban.selected = true;

      // console.log(
      //   "After:",
      //   item.jawaban.map((j) => j.selected)
      // );
      // Debugging log
      // self.getListSoal();
    },

    async selectAnswerMenjodohkan(item, selectedJawaban) {
      if (selectedJawaban === null) {
        // Send null to BE for deletion
        await this.simpanJawaban(item, { idjawaban: null, skor: 0 });
        // Clear local state
        const soalIndex = this.soalMenjodohkan.findIndex(
          (s) => s.idsoal === item.idsoal
        );
        if (soalIndex !== -1) {
          this.soalMenjodohkan[soalIndex].jawaban_redis = null;
          this.soalMenjodohkan[soalIndex].jawaban_peserta = null;
        }
        const listIndex = this.listItem.findIndex(
          (s) => s.idsoal === item.idsoal
        );
        if (listIndex !== -1) {
          this.listItem[listIndex].jawaban_redis = null;
          this.listItem[listIndex].jawaban_peserta = null;
        }
      } else {
        await this.simpanJawaban(item, selectedJawaban);
      }
    },

    async simpanJawaban(item, selectedJawaban) {
      let self = this;
      const minutes = Math.floor(this.countdown / 60);
      self.progressSaveData = false;

      // let proctorResult = null;
      // if (self.proctoringConfiguration.used) {
      //   try {
      //     proctorResult = await AutoProctorService.getResults(
      //       self.proctoringConfiguration.credentials.client_id,
      //       self.proctoringConfiguration.credentials.client_secret,
      //       self.proctoringConfiguration.credentials.testAttemptId,
      //     )

      //     console.log('Progress', proctorResult)
      //   } catch (e) {
      //     console.warn("Proctor not ready yet")
      //   }
      // }
      
      // Gabungkan persistent violations (dengan timestamp terkini) + live events soal ini.
      // Persistent = pelanggaran yang masih berlangsung (dual monitor, dll).
      // Live = pelanggaran baru sejak soal ini mulai dikerjakan.
      const persistentSnapshot = this.persistentViolations.map(v => ({
        ...v,
        timestamp: new Date().toISOString()
      }))
      const proctorEvidence = [...persistentSnapshot, ...this.proctorLiveEvents]

      console.log('Hasil Realtime', proctorEvidence);
      var config_store_data = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "peserta/jadwal-peserta/simpan-jawaban",
        data: {
          id_kompetensi: this.id_kompetensi,
          id_jawaban: selectedJawaban.idjawaban,
          id_jadwal_peserta: this.id_jadwal_peserta,
          id_soal: item.idsoal,
          id_jadwal: this.id_jadwal,
          id_status: this.id_status,
          skor: selectedJawaban.skor,
          id_jadwal_batch: this.id_jadwal_batch,
          time_remaining: minutes,
          is_simulasi: localStorage.getItem("is_simulasi"),
          uniqueId: localStorage.getItem("uniqueId"),
          proctor_evidence: proctorEvidence,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token_peserta,
        },
      };
      axios(config_store_data)
        .then(function (response) {
          self.progressSaveData = true;

          self.proctorLiveEvents = [];
          setTimeout(() => {
            self.progressSaveData = null;
          }, 2000);
          console.log("respon jawaban" + response);
          // if (self.last_page - 1 !== self.index_soal) {
          //   self.index_soal++;
          // }
          // Using self instead of this
          self.getListSoalRedis(); // Using self instead of this
        })
        .catch(function (error) {
          self.progressSaveData = false;
          self.axiosCatchError = error;
        });
    },

    async cekJawaban() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "peserta/jadwal-peserta/cek-jawaban",
        data: {
          id_kompetensi: this.id_kompetensi,
          id_jadwal_peserta: this.id_jadwal_peserta,
          id_jadwal: this.id_jadwal,
          id_status: this.id_status,
          level: this.level,
          is_simulasi: localStorage.getItem("is_simulasi"),
          uniqueId: localStorage.getItem("uniqueId"),
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token_peserta,
        },
      })
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
      return data;
    },

    async getListSoalRedis() {
      // console.log("callredis");
      let self = this;
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/list-soal-peserta-redis",
          {
            params: {
              id_kompetensi: this.id_kompetensi,
              idjadwal: this.id_jadwal,
              idjadwal_peserta: this.id_jadwal_peserta,
              level: this.level,
              is_simulasi: localStorage.getItem("is_simulasi"),
              uniqueId: localStorage.getItem("uniqueId"),
              // tipe: "Pilihan Ganda",
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          }
        );

        // console.log(response);
        let response_data = response.data;
        self.last_page = response_data.data.length;
        let data = response.data.data;

        if (response_data.meta.code == 200) {
          self.listItem = data;
          // console.log('huaaa');
          // self.groupedItems();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data.data.message,
          });
        }
      } catch (errors) {
        console.log(errors);
      }
    },

    shuffleArray(array) {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },

    // Bagian Menjodohkan
    nomorSoal(idsoal) {
      let grouped = [];
      let reset = 0;

      this.listItem.forEach((e, i) => {
        if (e.is_instruksi === 1) {
          reset = 0;
          grouped[e.idsoal] = 1;
        } else {
          reset++;
          e.nomor_urut = reset;
          this.listItem[i].nomor_urut = reset;
          grouped[e.idsoal] = reset;
        }
      });

      return grouped[idsoal];
    },

    previewImageToggle(url) {
      this.urlSrc = url;
      this.previewImage = true;
    },

    updateViewportHeight() {
      this.viewportHeight = window.innerHeight;
    },

    async saveInitialProctoringEvidence() {
      try {
        await axios({
          method: "post",
          url: this.BACKEND_URL_VERSION + "peserta/jadwal-peserta/save-proctor-session-start",
          data: {
            idjadwal: this.id_jadwal,
            idjadwal_peserta: this.id_jadwal_peserta,
            idjadwal_batch: this.id_jadwal_batch,
            idkompetensi: this.id_kompetensi,
            idstatus_peserta: this.id_status,
            evidence: {
              type: "session_start",
              message: "Peserta memasuki sesi ujian",
              timestamp: new Date().toISOString(),
              testAttemptId: this.proctoringConfiguration.credentials.testAttemptId,
            }
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token_peserta
          }
        })
      } catch (err) {
        console.warn("saveInitialProctoringEvidence failed:", err)
      }
    },

    _upsertPersistentViolation(violation) {
      const idx = this.persistentViolations.findIndex(v => v.code === violation.code)
      if (idx >= 0) {
        this.persistentViolations[idx] = { ...violation }
      } else {
        this.persistentViolations.push({ ...violation })
      }
    },

    restoreBodyScroll() {
      document.body.style.overflow = 'auto';
      document.body.style.overflowY = 'auto';
      document.body.style.paddingRight = '';
      document.body.classList.remove('swal2-shown', 'swal2-height-auto');
    },

    async cleanupProctoring() {
      if (!this.proctoringConfiguration.used) return

      // Hentikan semua stream media (kamera, mic, screen) — sync, langsung matikan indikator hardware
      AutoProctorService.cleanup()

      // Hentikan dan reset instance SDK AutoProctor
      await AutoProctorService.clearInstances()

      // Bersihkan permission change listeners
      for (const { status, onChange } of this.permissionMonitors) {
        status.removeEventListener('change', onChange)
      }
      this.permissionMonitors = []
      this.permissionLostAlertShown = false
    },
  },

  async beforeRouteLeave(_to, _from, next) {
    if (this._navigationConfirmed) {
      next();
      return;
    }

    await Swal.fire({
      icon: 'warning',
      title: 'Tidak Dapat Keluar!',
      text: 'Anda tidak diperbolehkan meninggalkan halaman ujian selama sesi berlangsung.',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    next(false);
  },

  beforeUnmount() {
    clearInterval(this.timerInterval);

    // cleanupProctoring sudah dipanggil di beforeRouteLeave, ini sebagai safety net
    // cleanup() sync untuk pastikan stream media benar-benar berhenti
    AutoProctorService.cleanup()

    window.removeEventListener("resize", this.updateViewportHeight);
    window.removeEventListener('popstate', this._handlePopState);
    window.removeEventListener('beforeunload', this._handleBeforeUnload);
  },
};
</script>

<template>
  <div
    v-if="
      !proctoringConfiguration.activeStatus ||
      proctoringConfiguration.loading ||
      proctoringConfiguration.preview
    "
    class="mym-quizz-dashboard"
    id="mym-quizz-container"
  >
    <ProctorPermissionsInfo
      v-if="proctoringConfiguration.used"
      :nama_kompetensi="nama_kompetensi"
      :level="level"
      :nip_peserta="nip_peserta"
      :proctoringConfiguration="proctoringConfiguration"
      @deactiveStatus="
        proctoringConfiguration.activeStatus = false;
        proctoringConfiguration.preview = false;
      "
      @stopPreview="stopPreviewProctoring"
    />
  </div>

  <div v-else class="mym-quizz-dashboard" id="mym-quizz-container">
    <div class="full-page-watermark">
      {{ nip_peserta }}
    </div>
    <div class="side-watermark side-watermark--left">
      {{ nip_peserta }}
    </div>
    <div class="side-watermark side-watermark--right">
      {{ nip_peserta }}
    </div>
    <HeaderSoalPeserta 
      ref="quizChild"
      :nama_kompetensi="nama_kompetensi"
      :level="level"
      :proctoringConfiguration="proctoringConfiguration"
      :progressSaveData="progressSaveData"
      :stopAutoProctor="stopAutoProctor"
      :infoPengerjaan="infoPengerjaan"
      :tipe="tipe"
      :formattedTime="formattedTime"
      @stopAutoProctor="stopAutoProctor"
      @showProgress="modalConfiguration.progress = true"
    />

    <div class="mym-quizz-body">
      <div v-if="isLoadingSoal" class="mym-container-body">
        <div class="mym-loading-card">
          <div class="mym-loading-spinner"></div>
          <p class="mym-loading-text">Memuat soal, mohon tunggu...</p>
        </div>
      </div>

      <div v-else-if="is_instruksi == 1" class="mym-container-body">
        <InstruksiSoalPilihanGanda
          v-if="tipe === 'Pilihan Ganda'"
          :soalStats="soalStats"
          :listItem="listItem"
          :currentQuestion="currentQuestion"
          :currentQuestionOptionList="currentQuestionOptionList"
          :currentQuestionShuffleOptionList="currentQuestionShuffleOptionList"
          :answers="answers"
          :currentIndex="currentIndex"
          :hasImageOptions="hasImageOptions"
          :selectAnswer="selectAnswer"
          :openProgressFinal="openProgressFinal"
          :nextSoal="nextSoal"
          :last_page="last_page"
          :index_soal="index_soal"
          :status_pengerjaan="status_pengerjaan"
        />

        <InstruksiSoalBenarSalah
          v-if="tipe === 'Benar Salah'"
          :soalStats="soalStats"
          :listItem="listItem"
          :currentQuestion="currentQuestion"
          :currentQuestionOptionList="currentQuestionOptionList"
          :currentQuestionShuffleOptionList="currentQuestionShuffleOptionList"
          :answers="answers"
          :currentIndex="currentIndex"
          :hasImageOptions="hasImageOptions"
          :selectAnswer="selectAnswer"
          :openProgressFinal="openProgressFinal"
          :nextSoal="nextSoal"
          :last_page="last_page"
          :index_soal="index_soal"
          :status_pengerjaan="status_pengerjaan"
        />

        <InstruksiSoalMenjodohkan
          v-if="tipe === 'Menjodohkan'"
          :soalStats="soalStats"
          :height="getHeaderHeight"
          :index_soal="index_soal"
          :list="soal"
          :currentPage="currentPage"
          :nextSoal="nextSoal"
        />

        <InstruksiSoalText
          v-if="tipe === 'Text'"
          :soalStats="soalStats"
          :currentQuestion="currentQuestion"
          :nextSoal="nextSoal"
          :index_soal="index_soal"
          :idJadwal="id_jadwal"
          :idJadwalPeserta="id_jadwal_peserta"
        />
      </div>

      <div v-else-if="is_instruksi == 0" class="mym-container-body">

        <SoalPilihanGanda
          v-if="tipe === 'Pilihan Ganda'"
          :soalStats="soalStats"
          :getQuestionNumber="getQuestionNumber"
          :listItem="listItem"
          :currentQuestion="currentQuestion"
          :currentQuestionOptionList="currentQuestionOptionList"
          :currentQuestionShuffleOptionList="currentQuestionShuffleOptionList"
          :answers="answers"
          :currentIndex="currentIndex"
          :hasImageOptions="hasImageOptions"
          :selectAnswer="selectAnswer"
          :openProgressFinal="openProgressFinal"
          :nextSoal="nextSoal"
          :last_page="last_page"
          :index_soal="index_soal"
          :status_pengerjaan="status_pengerjaan"
          @modalProgressFinal="modalConfiguration.progressFinal = true"
        />

        <SoalBenarSalah
          v-if="tipe === 'Benar Salah'"
          :soalStats="soalStats"
          :getQuestionNumber="getQuestionNumber"
          :listItem="listItem"
          :currentQuestion="currentQuestion"
          :currentQuestionOptionList="currentQuestionOptionList"
          :currentQuestionShuffleOptionList="currentQuestionShuffleOptionList"
          :answers="answers"
          :currentIndex="currentIndex"
          :hasImageOptions="hasImageOptions"
          :selectAnswer="selectAnswer"
          :openProgressFinal="openProgressFinal"
          :nextSoal="nextSoal"
          :last_page="last_page"
          :index_soal="index_soal"
          :status_pengerjaan="status_pengerjaan"
          @modalProgressFinal="modalConfiguration.progressFinal = true"
        />

        <SoalMenjodohkan
          v-if="tipe === 'Menjodohkan'"
          :soalStats="soalStats"
          :getQuestionNumber="getQuestionNumber"
          :key="soalMenjodohkan.length"
          :list="soalMenjodohkan"
          :height="getHeaderHeight"
          :currentPage="currentPage"
          :selectAnswer="selectAnswerMenjodohkan"
          :nomorUrut="nomor_urut"
          @showImage="previewImageToggle"
          :currentQuestionMenjodohkan="currentQuestionMenjodohkan"
          :last_page="last_page"
          :index_soal="index_soal"
          :status_pengerjaan="status_pengerjaan"
          :backSoal="backSoal"
          :nextSoal="nextSoal"
          @modalProgressFinal="modalConfiguration.progressFinal = true"
        />

        <SoalText
          v-if="tipe === 'Text'"
          :soalStats="soalStats"
          :currentQuestion="currentQuestion"
          :idJadwal="id_jadwal"
          :idJadwalPeserta="id_jadwal_peserta"
          :nextSoal="nextSoal"
          :last_page="last_page"
          :index_soal="index_soal"
          :status_pengerjaan="status_pengerjaan"
          :getListSoalRedis="getListSoalRedis"
          @modalProgressFinal="modalConfiguration.progressFinal = true"
        />
      </div>
    </div>
  </div>

  <ModalProgress
    v-model="modalConfiguration.progress"
    :getQuestionNumber="getQuestionNumber"
    :soalStats="soalStats"
    :listItem="listItem"
    :index_soal="index_soal"
  />

  <ModalProrgessFinal
    v-model="modalConfiguration.progressFinal"
    :getQuestionNumber="getQuestionNumber"
    :soalStats="soalStats"
    :listItem="listItem"
    :index_soal="index_soal"
    :cekSelesai="cekSelesai"
  />

  <div v-if="showModalInstruction" class="custom-modal-overlay">
    <div class="custom-modal large">
      <!-- Header -->
      <div class="modal-header-custom">
        <div class="icon-info">ℹ️</div>
        <h5>Petunjuk Pengerjaan</h5>
        <span class="close-btn" @click="showModalInstruction = false">×</span>
      </div>

      <!-- Body (SCROLLABLE) -->
      <div class="modal-body scrollable">
        <div class="mym-container-body">
          <PetunjukSoalPilihanGanda
            v-if="tipe == 'Pilihan Ganda'"            
            :currentQuestion="dataInfo"
            :hasImageOptions="hasImageOptions"
          />
          
          <PetunjukSoalBenarSalah
            v-if="tipe == 'Benar Salah'"
            :currentQuestion="dataInfo"
          />

          <PetunjukSoalMenjodohkan
            v-if="tipe == 'Menjodohkan'"
            :list="dataInfo"
          />

          <PetunjukSoalText
            v-if="tipe == 'Text'"
            :list="dataInfo"
            :idJadwal="id_jadwal"
            :idJadwalPeserta="id_jadwal_peserta"
          />
        </div>
      </div>

    </div>
  </div>

</template>
